import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { PickerFileAccessOptions } from './constants/fileAccess';
import IframeContainer from './internal/IframeContainer';
import { logNewRelicError } from './internal/utils';
let configureCalled = false;

const configureFileManager = ({
  uploadedFileAccess,
  disableUpload,
  withCanva,
  withShutterstock,
  specificCanvaTemplates
}) => {
  if (configureCalled) {
    console.warn('[FileManager] configureFileManager should only be called once');
  }

  configureCalled = true;

  if (!uploadedFileAccess) {
    throw new Error('[FileManager] uploadedFileAccess param is required');
  }

  if (!Object.keys(PickerFileAccessOptions).includes(uploadedFileAccess)) {
    throw new Error('[FileManager] configureFileManager passed invalid uploadedFileAccess param');
  }

  class FileManager extends PureComponent {
    constructor(...args) {
      super(...args);
      this.displayName = 'FileManager';
    }

    componentDidCatch(error) {
      logNewRelicError(error, {
        errorBoundary: true
      });
    }

    static getDerivedStateFromError() {
      return {
        errorCaught: true
      };
    }

    render() {
      const _this$props = this.props,
            {
        auth,
        children
      } = _this$props,
            rest = _objectWithoutPropertiesLoose(_this$props, ["auth", "children"]);

      return /*#__PURE__*/_jsx(IframeContainer, Object.assign({}, rest, {
        auth: auth,
        disableUpload: disableUpload,
        uploadedFileAccess: uploadedFileAccess,
        withCanva: withCanva,
        withShutterstock: withShutterstock,
        specificCanvaTemplates: specificCanvaTemplates,
        children: children
      }));
    }

  }

  return FileManager;
}; // call to allow unit tests to call `configureFileManager` multiple times


export const resetForTesting = () => {
  if ('jasmine' in window) {
    configureCalled = false;
  }
};
export default configureFileManager;